import { useState } from "react";
import { Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export const NewShowDialog = ({ onCreate }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ city: "", venue: "", date: new Date().toISOString().slice(0, 10) });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await onCreate(form);
    setBusy(false);
    if (ok) setOpen(false);
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} className="h-12 px-5 bg-[#636b2f] text-white hover:bg-[#737c37] font-bold rounded-md" data-testid="new-show-btn">
        <Plus className="w-5 h-5 mr-1" /> Novo show
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#15181E] border-[#2A2E39] text-white">
          <DialogHeader>
            <DialogTitle className="font-display uppercase tracking-wide">Novo carregamento</DialogTitle>
            <p className="text-sm text-slate-400">Cria um checklist novo com todos os caminhões e guinchos.</p>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="show-city">Cidade</Label>
              <Input id="show-city" required value={form.city} onChange={set("city")} placeholder="Ex: São Paulo" className="h-12 bg-[#0B0C10] border-[#2A2E39]" data-testid="new-show-city-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="show-venue">Local (opcional)</Label>
              <Input id="show-venue" value={form.venue} onChange={set("venue")} placeholder="Ex: Allianz Parque" className="h-12 bg-[#0B0C10] border-[#2A2E39]" data-testid="new-show-venue-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="show-date">Data</Label>
              <Input id="show-date" type="date" required value={form.date} onChange={set("date")} className="h-12 bg-[#0B0C10] border-[#2A2E39]" data-testid="new-show-date-input" />
            </div>
            <DialogFooter>
              <Button type="submit" disabled={busy} className="h-12 w-full bg-[#636b2f] text-white hover:bg-[#737c37] font-bold" data-testid="new-show-submit-btn">
                {busy ? "Criando..." : "Criar checklist"}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
